import { useTranslation } from "react-i18next";

const LanguageToggle = () => {
  const { i18n, t } = useTranslation();

  const toggleLang = () => {
    const newLang = i18n.language === "fr" ? "he" : "fr";
    i18n.changeLanguage(newLang);
    document.documentElement.dir = newLang === "he" ? "rtl" : "ltr";
    document.documentElement.lang = newLang;
  };

  return (
    <button
      data-testid="language-toggle"
      onClick={toggleLang}
      className="fixed top-6 left-6 z-50 bg-white/80 backdrop-blur-md border border-sand px-5 py-2.5 font-sans text-sm tracking-widest text-charcoal hover:bg-gold hover:text-white transition-all duration-300 rounded-sm shadow-soft"
    >
      {t("lang_toggle")}
    </button>
  );
};

export default LanguageToggle;
